import type { HandoffScreenUICopy } from './types';

export const HANDOFF: HandoffScreenUICopy = {
  pageTitle: 'Call handoffs',
  pageDescription:
    'Set handoff destinations for your agent to route to during conversations. Set a default handoff destination as a fallback.',
  button: {
    add: 'Handoff',
  },
  card: {
    defaultHandoffMismatchWarning:
      'This handoff is not compatible with the default handoff method for the integration. Please update the handoff method to match the default handoff method.',
  },
  empty: {
    connector: {
      title:
        "You'll need to connect your Twilio phone number using a SIP address before handing off agent calls.",
      button: {
        generateSIPAddress: 'Generate SIP address',
      },
    },
    handoff: {
      title: 'You have no handoffs so far',
      description: 'Click on "Add handoff" to get started',
    },
  },
  modal: {
    formHandoff: {
      methodChangedCallout: (method: string) =>
        `Your handoff method has been changed to ${method}. Please review your handoff configuration and click save if everything is correct.`,
    },
    generateSIPAddress: {
      title: 'Generate SIP address',
      button: {
        confirm: 'Done',
      },
    },
    add: {
      title: 'Add handoff',
      form: {
        destinationInput: {
          label: 'Name',
          placeholder: 'For example, "Front desk"',
          duplicateError: 'Handoff destination already exists',
        },
        routeInput: {
          label: 'Route',
          placeholder: 'For example, "abc123"',
          helpText: 'Route or SIP address of the request',
        },
        encryptionInput: {
          label: 'Encryption',
          helpText: 'Encryption type for the request',
        },
        integrationInput: {
          label: 'Integration name',
          placeholder: 'For example, "poly-integration"',
          helpText:
            'This is a pre-defined internal integration name. Speak with your PolyAI team to help use the right integration.',
        },
        methodInput: {
          label: 'Method',
          helpText: 'Select the SIP method required for your request',
        },
        sipHeadersInput: {
          label: 'SIP header',
          placeholder: 'For example, "Call-ID"',
          helpText: 'Define SIP headers sent with the request',
        },
        valueInput: {
          label: 'Value',
          placeholder: 'Header value',
        },
        descriptionInput: {
          label: 'Description',
          placeholder:
            'For example, "When the caller needs to speak with an operator"',
        },
      },
    },
  },
};
